import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Русский язык. 2 класс",
        subject: "Система работы по развитию орфографической зоркости  как основа преодоления трудностей формирования грамотного письма",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Система работы по развитию орфографической зоркости  как основа преодоления трудностей формирования грамотного письма",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Кузнецова Марина Ивановна",
                grade: "д.пед.н.",
                subGrade: "вед. научный сотрудник лаборатории начального общего образования ФГБНУ «Институт стратегии развития образования»",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: `<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>
                                    <p>Формирование орфографической грамотности всегда было одной из приоритетных целей обучения русскому языку в начальной школе.</p>
                                   <p>Однако изменения, происходящие в мире, например, насыщенность информационной среды, появление у современных младших школьников определённых особенностей восприятия, оказывают существенное влияние на результативность овладения навыком грамотного письма. </p>
                                   <p>Достаточно часто возникает разрыв между знанием правил и умением их применить. Одним из путей преодоления этого разрыва является систематическая работа по формированию орфографической зоркости. </p>
                                   <p>При знакомстве с кейсом педагог получит возможность уточнить для себя понятие «орфографическая грамотность», проанализировать распространённые педагогические установки, существенно тормозящие процесс формирования у младших школьников орфографической зоркости. </p>
                                   <p>Основное содержание кейса направлено на актуализацию эффективных приёмов формирования орфографической зоркости как условия и основы постановки орфографической задачи. Уделено внимание способам осознания второклассниками признаков орфограмм и обнаружения места возможного возникновения орфографической ошибки. </p>
                                   <p>Работа с материалами кейса поможет педагогу оценить эффективность собственной работы по формированию у обучающихся орфографической зоркости, повысить степень осознанности усвоения второклассниками орфографического материала, преодолеть трудности овладения орфографической грамотностью. </p>
                                    </div>`
                        }
                    ]
                },
                {
                    type: "table",
                    title: "Учебый предмет",
                    text: "Русский язык"
                },
                {
                    type: "table",
                    title: "Класс",
                    text: "2"
                },
                {
                    type: "table",
                    title: "Тема",
                    subtitle: "(место в разделе)",
                    text: "«Система работы по развитию орфографической зоркости  как основа преодоления трудностей формирования грамотного письма»\n" +
                        "Раздел «Орфография и пунктуация»: орфографическая зоркость как осознание места возможного возникновения орфографической ошибки; понятие орфограммы; различные способы решения орфографической задачи в зависимости от места орфограммы в слове. \n"
                },
                {
                    type: "table",
                    title: "Цель кейса",
                    text: "Проанализировать трудности формирования орфографической зоркости и их причины; представить эффективные способы развития у второклассников орфографической зоркости как прочной основы грамотного письма. "
                },
                {
                    type: "table",
                    title: "Планируемые результаты",
                    subtitle: "(для педагога)",
                    unorderedList: [
                        "совершенствовать педагогическое мастерство учителя в организации системы работы, направленной на формирование орфографической зоркости младших школьников;",
                        "привлечь внимание педагога к важности первого этапа орфографического действия – постановка орфографической задачи;",
                        "совершенствовать способность к педагогической рефлексии, позволяющей обнаружить связь собственных методических просчетов и ошибок в работах младших школьников."
                    ]
                },
                {
                    type: "table",
                    title: "Планируемые результаты",
                    subtitle: "(для обучающихся)",
                    children: [
                        {
                            type: "table",
                            listLabel: "Личностные:",
                            unorderedList: [
                                "проявлять интерес к изучению орфографии, активность и самостоятельность в решении орфографических задач;",
                                "осознавать правильную письменную речью как показатель общей культуры; осознавать важность овладения навыком безошибочного письма;"
                            ]
                        },
                        {
                            type: "table",
                            listLabel: "Метапредметные:",
                            unorderedList: [
                                "находить закономерности в процессе наблюдения за языковыми единицами;",
                                "планировать с помощью учителя действия по решению орфографической задачи;",
                                "выстраивать последовательность выбранных действий;",
                                "корректировать с помощью учителя свои учебные действия для преодоления ошибок при списывании текстов и записи под диктовку.",
                            ]
                        },
                        {
                            type: "table",
                            listLabel: "Предметные:",
                            unorderedList: [
                                "устанавливать соотношение звукового и буквенного состава слова;",
                                "находить место орфограммы в слове;",
                                "применять изученные правила правописания;",
                                "находить и исправлять ошибки на изученные правила, описки.",
                            ]
                        },
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 1",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video1.mp4",
            content: [
                {
                    type: "text",
                    text: `<p>В Федеральной рабочей программе по учебному предмету «Русский язык» поставлены следующие задачи, которые необходимо достичь школьнику совместно с педагогом:</p>
                    <p>
                        <ul>
                            <li>осознание правильной письменной речи как показателя общей культуры человека;</li>
                            <li>использование в речи орфографических и пунктуационных норм современного русского литературного языка.</li>
                        </ul>
                    </p>
                    <p>На сегодняшний день уровень орфографической грамотности младших школьников вызывает ряд вопросов.</p>
                    <p>Так, при списывании или письме под диктовку младшие школьники допускают меньше ошибок, чем при записи коротких письменных высказываний или собственных текстов. Другими словами, уровень функциональной орфографической грамотности, когда орфография выступает лишь средством передачи смысла высказывания, нельзя считать высоким.  </p>
                    <p>Каковы же причины большого количества орфографических ошибок в работах учеников?</p>
                    <p>Одна из главных причин – отсутствие орфографической зоркости как умения находить те места, где выбор письменного знака не определяется произношением. Обучающийся может прекрасно знать орфографические правила, но если он не понимает, когда их нужно применять, грамотно писать он не будет.</p>
                    <p>Ещё одна причина – недостаточный уровень самоконтроля, неумение найти допущенные ошибки при проверке собственных работ и не допустить их в процессе письма.
                    Однако существуют и субъективные причины низкого уровня грамотности у младших школьников. К ним можно отнести:
                    </p>
                    <p>
                        <ul>
                            <li>методические просчёты или отсутствие систематичности в работе педагога;</li>
                            <li>ориентацию на механическое запоминание правил.</li>
                        </ul>
                    </p>
                    <p>Приведём слова Маргариты Михайловны Разумовской, в которых она обращает внимание на суть педагогической работы: <i>«Знания должны «подаваться» не столько в виде классических определений и правил, сколько в форме речевого предписания, разъясняющего ученику суть явления, предлагающего способ действия».</i></p>
                    <p>Проанализируем наиболее распространённые педагогические установки, которые тормозят процесс формирования у младших школьников орфографической зоркости.</p>
                    `
                }
            ]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль. Часть 1",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 2",
            imagePath: "",
            id: "2",
            videoUrl: "./video/video2.mp4",
            content: [
                {
                    type: "text",
                    text: `<p>Проанализировав самые частотные заблуждения, перечислим основные содержательные линии  в системе работы над орфографической зоркостью во 2 классе.</p>
                        <p>Ещё раз подчеркнём, что для преодоления трудностей формирования орфографической зоркости важно использовать именно систему работы.</p>
                    `
                }
            ]
        },
        {
            order: 5,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль. Часть 2",
            htmlPath: "./interactive/dist2/index.html",
            autoHeight: false
        },
        {
            order: 6,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Федеральный государственный образовательный стандарт начального общего образования, утвержден Приказом Министерства просвещения Российской Федерации от 31 мая 2021 г. № 286",
                "Федеральная образовательная программа начального общего образования, утверждена Приказом Министерства просвещения России от 16.11.2022 N 992, зарегистрировано в Минюсте России 22.12.2022 N 71762.",
                "Федеральная рабочая программа начального общего образования предмета «Русский язык»",
                "Беседы с учителем: Второй класс четырехлетней начальной школы / Под ред. Л.Е. Журовой. – М.: Вентана - Графф, 2018. – 320 с",
                "Панов М.В. И всё-таки она хорошая! Русская орфография. – Вербум-М. 2007 ",
                "Разумовская М.М. Методика обучения орфографии в школе: книга для учителя / М.М.Разумовская. – М.: Просвещение, 1992. – 190 с.",
                "Русский язык в начальных классах: теория и практика обучения. Под редакцией М.С. Соловейчик. М. Просвещение, 1993 г. 383 с. ",
            ],
            filesToDownload: [
                {
                    link: "./files/additional.pdf",
                    fileName: "Дополнительные задания, которые можно использовать для формирования орфографической зоркости"
                }
            ]
        }
    ],
};
